import request from '@/utils/request'

export function updateMiningCfg(data) {
  return request({
    url: 'api/v1/mining-config/update',
    method: 'post',
    data: data
  })
}

export function getMiningList(data) {
  return request({
    url: 'api/v1/mining-config/getList',
    method: 'post',
    data: data
  })
}

export function exportMining(data) {
  return request({
    url: 'api/v1/mining-config/export',
    method: 'post',
    data: data
  })
}

export function importMining(data) {
  return request({
    url: 'api/v1/mining-config/import',
    method: 'post',
    data: data
  })
}

export function delMining(data) {
  return request({
    url: 'api/v1/mining-config/delete',
    method: 'delete',
    data: data
  })
}

export function uploadMiningJson(data) {
  return request({
    url: 'api/v1/mining-config/updateCdn',
    method: 'post',
    data: data,
    timeout: 50000
  })
}
